export const IS_LOCAL = false;
export const IS_PRODUCTION = true;

export const PRODUCTION_FRONTEND_URL  = IS_PRODUCTION ? "https://thefoodeshow.elaatmani.com/" : "https://dev/";
export const PRODUCTION_BACKEND_URL   = IS_PRODUCTION ? "https://thefoodeshowapi.elaatmani.com/" : "https://api.dev/";

export const DEVELOPMENT_FRONTEND_URL = "http://localhost:8080/";
export const DEVELOPMENT_BACKEND_URL  = "http://localhost:8000/";
export const PREFIX                   = "eshow_";
export const DEFAULT_LANGUAGE         = "en";
export const APP_NAME                 = "The FoodEshow";

export const FRONTEND_URL = IS_LOCAL ? DEVELOPMENT_FRONTEND_URL : PRODUCTION_FRONTEND_URL;
export const BACKEND_URL  = IS_LOCAL ? DEVELOPMENT_BACKEND_URL  : PRODUCTION_BACKEND_URL;

// Pusher Configuration
export const PUSHER_KEY = 'fd77760e268fd35818c6';
export const PUSHER_CLUSTER = 'eu';
export const PUSHER_ENCRYPTED = true;